module.exports = __webpack_public_path__ + "img/calendar.b7630068.png";